import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar } from 'antd';

import { TvPlanContext } from "../../contexts/tvplancontext";

import './index.css';


function AppxLangAvatar() {
    const ctx = useContext(TvPlanContext);
    const { t, i18n } = useTranslation('tvplan');
    const changeLanguage = () => {
        let lang = (i18n.language === "en") ? 'fr' : 'en';
        ctx.setLang(lang);

        let uu = window.location.href || "";
        let [urlbase,qs] = uu.split("?");
        if ( typeof qs !== "string" ) { qs = "";}
        let argsPairs = qs.split("&");
        let args = {};
        for (let argp of argsPairs) {
            let [k,v]= argp.split("=");
            args[k] = v;
        }

        let newqs = "";
        args["lang"] = lang;

        for (let k in args) {
            if ( k.toString() === "undefined" ) { continue;}
            if ( k.length < 1 ) { continue;}
            let v= args[k];
            newqs += "&" + k + "=" + v;
        }
        let newUrl = urlbase + "?" + newqs;
        //await uri.set('lang', lang);
        window.history.replaceState(null, null, newUrl);
    };

    return (
        <div
            className="tv-drawer-lang"
            onClick={changeLanguage}>
            <Avatar style={{ color: '#fff', backgroundColor: '#000' }}>
                {t('lang_avatar_alt')}
            </Avatar>
        </div>
    );
}

export default AppxLangAvatar;
